import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import spinnerTitle from "components/others/spinnerTitle";
import SvgSave from "components/svg/SvgSave";
import AddServiceFormik from "./AddServiceFormik";
import { useRef, useState } from "react";
 
const AddServiceModal = ({show, setShow, teamId = null, isOther = false}) => {

    const { t } = useTranslation(['Objects']);
    const [ submittingFormik, setSubmittingFormik ] = useState(false);
    const refFormik = useRef();
     
    return (<>
         
        <Modal 
            show={!!show} 
            onHide={()=>setShow(false)}
            onShow={()=>setSubmittingFormik(false)}
            size="xl"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton className="border-bottom">
                <Modal.Title>{t('addService.btnAddService')}</Modal.Title> 
            </Modal.Header>
            <Modal.Body >
                {show && (
                    <AddServiceFormik
                        setShowTeam={setShow}
                        setSubmittingFormik={setSubmittingFormik}
                        refFormik={refFormik}
                        teamId={teamId}
                        isOther={isOther}/>
                )}

            </Modal.Body> 
            <Modal.Footer>
                <Button className="me-1"
                    variant="secondary"
                    disabled={submittingFormik}
                    onClick={()=>setShow(false)}>
                    {t('common:buttons.close')}
                </Button>
                <Button variant="info"
                    type="submit"
                    onClick={()=>{
                        refFormik.current.submitForm();
                    }}>
                    {spinnerTitle((<><SvgSave className="me-2 mtop-2"/>{t('common:buttons.save')}</>), submittingFormik, t('common:buttons.saving'))}
                </Button>
                 
            </Modal.Footer>
        </Modal> 
    </>)
}

export default AddServiceModal;
